import { Injectable } from '@angular/core';
import { BaseFiltrableItemService } from '@common-modules/shared/charts/base-filtrable-item.service';
import { DateHelperService } from '@common-modules/shared/helpers/date-helper.service';
import {
  ISerieDataPointDto,
  SerieDataPointDto,
} from '@common-modules/shared/model/chart/serie-data-point.dto';
import { IFiltrableItemQueryDto } from '@common-modules/shared/model/filtrable-items/filtrable-item-query.dto';
import { FiltrableItemTypeEnum } from '@common-modules/shared/model/filtrable-items/types/filtrable-item-type-enum';
import { EventChartQueryDto } from '@common-modules/wlm-charts/core/events-chart/models/events-chart-query.dto';

import { CTResultFiltrableItemDto } from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/ct-result-filtrable-item';
import { MeasurementSerieDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { CTMeasurementFiltrableItemDto, CTMeasurementFiltrableItemQueryDto, CTMeasurementFiltrableType } from '../ct-measurement-filtrable-item';

@Injectable({
  providedIn: 'root',
})
export class MeasurementsFiltrableItemService extends BaseFiltrableItemService {
  readonly type: FiltrableItemTypeEnum = FiltrableItemTypeEnum.CTMeasurement;

  constructor(private readonly _dateHelperService: DateHelperService) {
    super();
  }

  setDateRange(filtrableItem: CTMeasurementFiltrableItemDto, startDate: Date, endDate: Date): void {
    filtrableItem.startDate = startDate;
    filtrableItem.endDate = endDate;
  }

  getQuery(filtrableItem: CTMeasurementFiltrableItemDto): IFiltrableItemQueryDto {
    const { startDate, endDate, filtrableType } = filtrableItem;

    return new CTMeasurementFiltrableItemQueryDto(
      new Date(startDate),
      this._dateHelperService.addDays(new Date(endDate), 1),
      '',
      filtrableType.workspaceConnectSetting.scenarioId,
      filtrableType.pointId,
    );
  }

  getDataPoints(
    filtrableType: CTMeasurementFiltrableType,
    data: MeasurementSerieDto
  ): ISerieDataPointDto[] {
    const serieDataPoints = data.values;

    var dataPoints = Object.keys(serieDataPoints).map(
      (p) =>
        new SerieDataPointDto(
          filtrableType.key,
          p,
          +serieDataPoints[p],
          false,
          false,
          0,
          false
        )
    );

    return dataPoints;
  }

  getEventQuery(filtrableItem: CTResultFiltrableItemDto): EventChartQueryDto {
    return null;
  }
}
